import { useCallback, useState } from 'react';

export const usePrevModal = (onHideModal) => {
    const [secondModal, setSecondModal] = useState(null);

    const onSecondModal = useCallback((value) => {
        setSecondModal(value);
    }, []);

    const onHideSecondModal = useCallback(() => {
        setSecondModal(null);
        if (secondModal === 'delete') {
            onHideModal();
        }
    }, [onHideModal, secondModal]);

    return { secondModal, onSecondModal, onHideSecondModal };
};
